<!-- src/components/price_list_grid.vue -->
<template src="./price_list_grid.html"></template>

<script>

import {API_URL} from '@/main'
import axios from "axios"
import Utility from '@/utility.js'
import { ref, watch, computed, provide, inject } from 'vue'

import '@vuepic/vue-datepicker/dist/main.css'

import FilterBar from "@/components/dashboard/filter_bar.vue"

export default {
  name: "PriceListsGrid",
  emits: ['refresh-list'],
  components: {
    FilterBar,
  },
  props: {
    selectedName: {
      type: [String, Number],
      default: null
    },
    search: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      base: '',
      bracket_measure_unit: '',
      calculation_formula: '',
      checkedRowsList: [],
      customer: '',
      currentPage: 1,
      currency: '',
      end_date: '',
      id: null,
      isLoading: false,
      location_code1: '',
      location_code2: '',
      lower_end_bracket: null,
      perPage: 10,
      price_list_name: '',
      prices_list_columns: [
        { label: "", key: 'id', sortable: false, tdStyle: { width: '0%' } },
        { label: "Listino", key: 'price_list_name', sortable: false, tdStyle: { width: '10%' } },
        { label: "Voce", key: 'voice_name', sortable: false, tdStyle: { width: '10%' } },
        { label: "Cliente", key: 'customer', sortable: false, tdStyle: { width: '40%' } },
        { label: "Valuta", key: 'currency', sortable: false, tdStyle: { width: '05%' } },
        { label: "Data inizio", key: 'start_date', sortable: false, tdStyle: { width: '05%' } },
        { label: "Data fine", key: 'end_date', sortable: false, tdStyle: { width: '05%' } },
        { label: "Loc 1", key: 'location_code1', sortable: false, tdStyle: { width: '10%' } },
        { label: "Loc 2", key: 'location_code2', sortable: false, tdStyle: { width: '10%' } },
        { label: "Base", key: 'base', sortable: false, tdStyle: { width: '10%' } },
        { label: "Formula", key: 'calculation_formula', sortable: false, tdStyle: { width: '10%' } },
        { label: "Prezzo", key: 'unit_amount', sortable: false, tdStyle: { width: '10%' } },
        { label: '', key: 'checkboxes', sortable: false, tdStyle: { width: '5%' }, thClass: 'text-center', tdClass: 'text-center' },
      ],
      rows: 0,
      selectAll: false,      
      sortBy: null,
      sortDesc: false,
      start_date: '',
      totalRows: 0,
      unit_amount: null,
      upper_end_bracket: null,
    }
  },
  setup() {

    const prices_list_rows = ref([])
    const selectAll = ref(false)

    const checkedIds = computed(() => {
      
      return prices_list_rows.value
        .filter((item) => item.checked)
        .map((item) => item.id)
    })

    const onSelectAll = () => {    

      updateAllCheckboxes(selectAll.value)
    }    
    
    const toggleAll = () => {
    
      updateCheckboxes(selectAll.value)
    }

    const updateAllCheckboxes = (checkedValue) => {
    
      const updatedRows = prices_list_rows.value.map((item) => {

        return {
            ...item,
            checked: newValue,
        }
      })
    }

    const updateCheckboxes = (newValue) => {
    
      const updatedRows = prices_list_rows.value.map(item => {
        return {
          ...item,
          checked: newValue
        }
      })
      prices_list_rows.value = updatedRows
    }


    watch(prices_list_rows.value, (newValue, oldValue) => {
    
      console.log("prices_list_rows changed", newValue);
    }, { deep: true })

    return {
      checkedIds,      
      onSelectAll,
      prices_list_rows,
      selectAll,
      toggleAll,
      updateAllCheckboxes,
    }
  },
  watch: {
    isLoading(newVal) {
    
    },
  },
  computed: {
    checkedIds() {
      return this.prices_list_rows
        .filter(item => item.checked)
        .map(item => item.id)
    },
    selectedName() {
     
      return this.name?.id || null
    },     
    totalPages() {

      return Utility.Utility.roundUpIfNotInteger(this.totalRows, this.perPage)
    },
  },     
  created() {
  
  },
  mounted() {

    this.loadPricesList()
  },
  methods: {
    checkIfChecked(id) {
          
      return this.checkedRowsList.includes(id)
    },  
    async loadPricesList() {

      console.debug("### token", localStorage.getItem("Token")," User-ID", localStorage.getItem("User_id"))

      this.isLoading = true
      const checkedRowsList = inject("checkedRowsList")

      try {

        const url = API_URL + "price_list/PriceListList/"
        let requestData = {
          params: {
            name: null,
            page: this.currentPage,
            per_page: this.perPage,
          },
        }
        
        if(this.selectedName !== null) {
          
          requestData.params.name = this.selectedName
        }

        if(this.search !== null){

          requestData.params.search = this.search
        }

        const headers = {
          token: localStorage.getItem("Token"),
          "User-ID": localStorage.getItem("User_id"),
        }
        
        console.debug("**loadPriceList headers", headers) /**/
        const response = await axios.get(url, {params: requestData.params, headers: headers})

        this.prices_list_rows = {}
        this.totalRows = response.data.count
        this.rows = response.data.count
        const newData = JSON.parse(JSON.stringify(response.data.results))

        this.prices_list_rows = newData.map(price => ({
          id: price.id,
          base: price.base?.base_code ?? '',
          bracket_measure_unit: price.bracket_measure_unit,
          calculation_formula: price.calculation_formula.formula,
          checked: this.checkIfChecked(price.id), //checkIfChecked.value.includes(price.id),
          currency: price.currency?.currency ?? '',
          customer: price.customer?.company ?? '',
          end_date: this.formatDate(price.end_date),
          good_kind: price.good_kind,
          location_code1: price.location_code1?.location ?? '',
          location_code2: price.location_code2?.location ?? '',
          lower_end_bracket: price.lower_end_bracket,
          packaging_kind: price.packaging_kind ?? null,
          price_list_name: price.price_list_name,
          start_date: this.formatDate(price.start_date),
          unit_amount: price.unit_amount,
          upper_end_bracket: price.upper_end_bracket,
          voice_name: price.voice_name,
        }))

        this.prices_list_rows = [...this.prices_list_rows]
      } 
      catch (error) {
    
        console.debug("Failed to load price list:", error);
      } 
      finally {

        this.$nextTick(() => {
          
          this.isLoading = false
        })
      }
    },
    formatDate(date) {
  
      if(!date) {

        return ''
      }

      return date.slice(8, 10) + "-" + date.slice(5, 7) + "-" + date.slice(0, 4)
    },    
    onCheckboxChange(item) {
     
      if(item.checked) {
        
        if(!this.checkedRowsList.includes(item.id)) {
          
          this.checkedRowsList.push(item.id)
        }
      } 
      else {
      
        this.checkedRowsList = this.checkedRowsList.filter(id => id !== item.id)
      }

      this.$emit('items-rows-selected', this.checkedRowsList)
    },
    async onRowClick(row) {

      this.$emit('row-selected', row.id)
    },
    onPageChange(page) {

      this.currentPage = page
      this.loadPricesList(this.selectedValue)      
    },
    async reloadPricesList() {
      
      console.log("Reloading prices list...")
      await this.loadPricesList()
    },    
  },
}
</script>

